export const maybeAppendProtocol = (url) => {
    if (url === '' || url.startsWith('http://') || url.startsWith('https://')) {
        return url;
    }
    return `https://${url}`;
};
//# sourceMappingURL=maybeAppendProtocol.js.map